import React from "react";
import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import AppShell from "@/layouts/AppShell";
import CommandCenter from "@/pages/CommandCenter";
import AiDiscovery from "@/pages/AiDiscovery";
import AiInventory from "@/pages/AiInventory";
import AgentDetail from "@/pages/AgentDetail";
import PolicyEditor from "@/pages/PolicyEditor";
import RuntimeMonitor from "@/pages/RuntimeMonitor";
import HumanOversight from "@/pages/HumanOversight";
import AuditCenter from "@/pages/AuditCenter";
import SettingsPage from "@/pages/Settings";
import KpiExplorer from "@/pages/KpiExplorer";
import AuthCallback from "@/components/aieco/AuthCallback";
import { WorkspaceProvider } from "@/context/WorkspaceContext";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Detect session_id during render (synchronous, prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<CommandCenter />} />
        <Route path="/discovery" element={<AiDiscovery />} />
        <Route path="/inventory" element={<AiInventory />} />
        <Route path="/inventory/:agentId" element={<AgentDetail />} />
        <Route path="/inventory/:agentId/policy" element={<PolicyEditor />} />
        <Route path="/runtime" element={<RuntimeMonitor />} />
        <Route path="/oversight" element={<HumanOversight />} />
        <Route path="/audit" element={<AuditCenter />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/explore/:kpiKey" element={<KpiExplorer />} />
      </Routes>
    </AppShell>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <WorkspaceProvider>
          <AuthProvider>
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
          </AuthProvider>
        </WorkspaceProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
